/* eslint-disable indent,no-use-before-define,no-undef,prefer-arrow-callback,no-var,no-trailing-spaces,prefer-template,arrow-body-style,padded-blocks,no-,no-restricted-syntax,curly,object-curly-spacing,no-case-declarations,no-unused-vars,prefer-const */
/**
 * Activation Services Controller file
 * @class
 */

class argumentableFunc {

    constructor(arg, fn) {

        this.arg = arg;

        this.func = fn;

        this.execute = () => {
            this.func(this.arg);
        };

    }

}


class MapsAddressController {
    /* @ngInject */
    constructor($scope, $filter, NgMap) {
        const that = this;

        that.map = null;

        that.postInitExecutionQueue = [];

        that.registeredPolygons = [];

        that.center = [];

        that.selectedAreasGeoJson = {};

        that.getSelectedAreasGeoJson = () => {
            return that.selectedAreasGeoJson;
        };

        const setCenter = (latLng, obj) => {
            that.center = latLng;
            that.map.setCenter(latLng);
            that.ngModel = obj;
        };

        that.onSearchChanged = function () {
            that.place = this.getPlace();
            setCenter(that.place.geometry.location, that.place);
            console.log('location', that.place.geometry.location);
        };

        that.modifyCompleted = (e) => {

            console.log("map event: " + e);

        };

        this.normalizePath = (path) => {

            let normalizedPath = [];

            angular.forEach(path, (point) => {

                    normalizedPath.push(
                        {
                            lat: point[0],
                            lng: point[1]
                        }
                    );

                }
            );

            return normalizedPath;

        }

        that.drawCompleted = (e) => {
            that.registeredPolygons.push(e.overlay);
            return false;
        };

        const getDefaultPolygonOption = (shapesVector) => {

            const options = {
                paths: shapesVector,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 5,
                editable: true,
                draggable: true,
                clickable: true,
                fillColor: '#FF0000',
                fillOpacity: 0.35

            };

            return options;
        };

        const convertToGeoJson = (polygons) => {

            const exportableGeoJsonObject = {

                type: "FeatureCollection",
                features: []
            };

            angular.forEach(polygons, (polygon) => {

                exportableGeoJsonObject.features.push(
                    {
                        type: "Feature",
                        properties: {},
                        geometry: {
                            type: "Polygon",
                            coordinates: [polygon]
                        }
                    }
                )

            });

            return exportableGeoJsonObject;
        };

        const getShapes = () => {
            const shapesToExport = [];
            angular.forEach(that.registeredPolygons,
                (polygon) => {
                    const path = polygon.getPath();
                    const convertedPolygon = convertShapesForExport(path);
                    shapesToExport.push(convertedPolygon);
                }
            );

            return convertToGeoJson(shapesToExport);
        };

        const setShapes = (geoJsonPolygons) => {
            

            if (!(geoJsonPolygons.features instanceof Array)) return;

            const effectiveSetShape = (geoJson) => {

                angular.forEach(geoJson.features,
                    (feature) => {

                        const normalizedShape = convertGeoJsonFeatureForImport(feature);
                        let polygon = drawPolygon(normalizedShape);
                        that.registeredPolygons.push(polygon);

                    },
                    that
                );

            };
            if (that.map === null)
                that.postInitExecutionQueue.push(new argumentableFunc(geoJsonPolygons, effectiveSetShape));
            else
                effectiveSetShape(geoJsonPolygons);
        };

        const convertGeoJsonFeatureForImport = (geoJsonFeature) => {

            let normalizedPoints = [];

            angular.forEach(geoJsonFeature.geometry.coordinates[0],
                (point) => {
                    normalizedPoints.push({lng: point[0], lat: point[1]});
                }
            );

            return normalizedPoints;

        };

        const convertShapesForExport = (polygon) => {

            let denormalizedPolygon = [];

            angular.forEach(polygon,
                (shape) => {
                    denormalizedPolygon.push([shape.lng(), shape.lat()])
                }
            );
            
            const firstElem = JSON.stringify(denormalizedPolygon[0]);
            const lastElem = JSON.stringify(denormalizedPolygon[denormalizedPolygon.length -1]);
            //First element and last element must coincide. If they're already the same we do nothing
            if (lastElem != firstElem) {
                denormalizedPolygon.push(denormalizedPolygon[0]);
            }
            
            return denormalizedPolygon;

        };

        const drawPolygon = (shapeVector) => {

            let normalizedShape = shapeVector;

            const polygonOption = getDefaultPolygonOption(normalizedShape);

            let polygon = new google.maps.Polygon(polygonOption);

            polygon.setMap(that.map);

            return polygon;

        };

        that.eraseAllPolygons = () => {

            while (that.registeredPolygons.length !== 0) {
                let currentPolygon = that.registeredPolygons[0];
                erasePolygon(currentPolygon);
            }
            NgMap.getMap({id: 'oed_map' }).then(function(map) {
                google.maps.event.trigger(map, 'resize');
            });
        };

        const erasePolygon = (polygon) => {

            polygon.setMap(null);
            const polygonIndex = that.registeredPolygons.indexOf(polygon);
            that.registeredPolygons.splice(polygonIndex, 1);
        };

        const initMap = () => {
            NgMap.getMap().then((map) => {
                that.map = map;

                angular.forEach(that.postInitExecutionQueue,
                    (registeredFunc) => {
                        registeredFunc.execute();
                    }
                );

            });
        };


        const init = () => {

            this.registeredPolygons = [];
            this.positions = [];
            this.setShapes = setShapes;
            this.getShapes = getShapes;

            initMap();
            
        };

        that.$onInit = init;
    }


}

export default MapsAddressController;




/** WEBPACK FOOTER **
 ** ./client/app/common/components/mapsAddress/mapsAddress.controller.js
 **/